import { createDashboardBuilderMockAdapter } from './dashboardBuilderMockAdapter';

/**
 * Dashboard Builder Service
 * TODO: Reemplazar mocks con endpoints reales
 * Formato de widget instance alineado con CT-2466:
 *   name, description, actions[] vienen del merge
 *   Type → Catalog → Instance (el backend hará el merge)
 */

const MOCK_LATENCY_MS = 400;

// ──────────────────────────────────────────────────────
// HELPERS
// ──────────────────────────────────────────────────────

const mockDelay = (data) =>
  new Promise((resolve) => setTimeout(() => resolve(data), MOCK_LATENCY_MS));

const mockAdapter = createDashboardBuilderMockAdapter();

// ──────────────────────────────────────────────────────
// SERVICE FUNCTIONS (mock → real endpoint)
// ──────────────────────────────────────────────────────

// TODO: Reemplazar mock con POST /v1/dashboard/list
export const getDashboards = async (params = {}) => {
  const filtered = mockAdapter.findDashboards(params);

  return mockDelay({
    status_code: 200,
    body: filtered,
    meta: { total_items: filtered.length, current_page: 1 },
  });
};

// TODO: Reemplazar mock con GET /v1/dashboard/:id
export const getDashboardById = async (id) => {
  const dashboard = mockAdapter.findDashboardById(id);
  if (!dashboard) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 200, body: dashboard });
};

// TODO: Reemplazar mock con POST /v1/dashboard/create
export const createDashboard = async (data) => {
  const newDashboard = mockAdapter.insertDashboard({
    ...data,
    state: 'draft',
  });
  return mockDelay({ status_code: 201, body: newDashboard });
};

// TODO: Reemplazar mock con POST /v1/dashboard/:id/duplicate
export const duplicateDashboard = async (id) => {
  const duplicated = mockAdapter.duplicateDashboard(id);
  if (!duplicated) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 201, body: duplicated });
};

// TODO: Reemplazar mock con PUT /v1/dashboard/:id
export const updateDashboard = async (id, data) => {
  const updated = mockAdapter.patchDashboard(id, data);
  if (!updated) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 200, body: updated });
};

// TODO: Reemplazar mock con DELETE /v1/dashboard/:id
export const deleteDashboard = async (id) => {
  const deleted = mockAdapter.removeDashboard(id);
  if (!deleted) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 200, body: { deleted: true } });
};

// TODO: Reemplazar mock con POST /v1/dashboard/:id/publish
export const publishDashboard = async (id) => {
  return updateDashboard(id, { state: 'published' });
};

// TODO: Reemplazar mock con POST /v1/dashboard/:id/archive
export const archiveDashboard = async (id) => {
  const archived = mockAdapter.archiveDashboard(id);
  if (!archived) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 200, body: archived });
};

// TODO: Reemplazar mock con POST /v1/dashboard/:id/unarchive
export const unarchiveDashboard = async (id) => {
  const unarchived = mockAdapter.unarchiveDashboard(id);
  if (!unarchived) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 200, body: unarchived });
};

// TODO: Reemplazar mock con GET /v1/dashboard/sections
export const getAvailableSections = async () => {
  return mockDelay({ status_code: 200, body: mockAdapter.getSections() });
};

// TODO: Reemplazar mock con POST /v1/dashboard/widgets
export const getAvailableWidgets = async (_sectionId) => {
  return mockDelay({ status_code: 200, body: mockAdapter.getWidgets() });
};

// TODO: Reemplazar mock con GET /v1/dashboard/template-categories
export const getTemplateCategories = async () => {
  return mockDelay({ status_code: 200, body: mockAdapter.getTemplateCategories() });
};

// TODO: Reemplazar mock con GET /v1/dashboard/templates
export const getTemplates = async (params = {}) => {
  const filtered = mockAdapter.findTemplates(params);

  return mockDelay({
    status_code: 200,
    body: filtered,
    meta: { total_items: filtered.length },
  });
};

// TODO: Reemplazar mock con POST /v1/dashboard/:id/share
export const shareDashboard = async (id, assignments) => {
  const dashboard = mockAdapter.appendDashboardShares(id, assignments);
  if (!dashboard) throw new Error('Dashboard not found');
  return mockDelay({ status_code: 200, body: dashboard });
};

// TODO: Reemplazar mock con PUT /v1/dashboard/:id/widget/:widgetId/layout
export const updateWidgetLayout = async (dashboardId, layouts) => {
  return mockDelay({ status_code: 200, body: { updated: true } });
};

// TODO: Reemplazar mock con PUT /v1/dashboard/:id/widget/:widgetId/name
export const updateWidgetName = async (dashboardId, widgetId, name) => {
  return mockDelay({ status_code: 200, body: { widgetId, name } });
};

// TODO: Reemplazar mock con PUT /v1/dashboard/:id/widget/:widgetId/lock
export const toggleWidgetLock = async (dashboardId, widgetId, locked) => {
  return mockDelay({ status_code: 200, body: { widgetId, locked } });
};
